<template>
  <span v-if="progress" class="progress-state" :class="{ 'is-static': readOnly }" role="status" aria-live="polite" aria-atomic="true">
    <transition name="progress-text" mode="out-in">
      <span :key="label" class="progress-text">{{ label || '正在处理你的请求' }}</span>
    </transition>
  </span>
  <span v-else class="execution-state" :class="'tone-' + state.tone" role="status">
    <span>{{ label || state.label }}</span>
  </span>
</template>
<script>
import { taskState } from '@/ai/presentation/task-states'
// 任务和批量结果共用呈现；不从文案推断结果，不改变执行、权限或重试逻辑。
export default {
  props: { status: String, label: String, readOnly: Boolean, progress: Boolean },
  computed: { state() { return taskState({ executionStatus: this.status }) } }
}
</script>
<style scoped src="./state-palette.css"></style>
<style scoped>
/* Progress mode owns animation and transitions. Polling must not randomize its text.
   Read-only history and reduced-motion users receive stable plain text. */
.progress-state { display:block;min-height:24px;line-height:24px;font-size:14px;color:#637185; }
.progress-text { display:inline-block;animation:progress-breathe 2s ease-in-out infinite; }
.progress-text-enter-active,.progress-text-leave-active { animation:none;transition:opacity .12s ease,transform .12s ease; }
.progress-text-enter,.progress-text-leave-to { opacity:0;transform:translateY(2px); }
@keyframes progress-breathe { 0%,100% { opacity:.65; } 50% { opacity:1; } }
.is-static .progress-text { animation:none; }
.is-static .progress-text-enter-active,.is-static .progress-text-leave-active { transition:none; }
@media(prefers-reduced-motion:reduce) {
 .progress-text { animation:none; }
 .progress-text-enter-active,.progress-text-leave-active { animation:none;transition:none; }
 .progress-text-enter,.progress-text-leave-to { transform:none; }
}
.execution-state { display:inline-flex;align-items:flex-start;gap:6px;min-width:0;font-size:13px;line-height:20px;color:var(--ai-state-color, #637185); }
.execution-state span { overflow-wrap:anywhere; }
</style>
